import { render } from "./RevisedHeader.vue?vue&type=template&id=f84858f0&scoped=true"
import script from "./RevisedHeader.vue?vue&type=script&lang=js"
export * from "./RevisedHeader.vue?vue&type=script&lang=js"

import "./RevisedHeader.vue?vue&type=style&index=0&id=f84858f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f84858f0"]])

export default __exports__